/**
 * The marker the GDPR encryption service writes into every PII field it encrypts. The employee
 * external reference carries it with the employee id appended (`[encrypted]-42`), so a field is
 * recognised by its prefix rather than by equality.
 *
 * @see cloud-run/internal/pkg/models/baseentity.go
 */
export const ENCRYPTED_MARKER = '[encrypted]'

/**
 * The prefix of the earlier one-off anonymisation runs, which wrote `anonymized_<ciphertext>` into
 * the name fields and `anonymized_<id>@<domain>` into the email. Those employees have to read the
 * same way as the ones the current pipeline encrypts.
 *
 * @see legacy/src/App/Everphone/Migration/Controller/GDPR/EncryptEmployeeController.php
 */
export const LEGACY_ANONYMISED_PREFIX = 'anonymized_'

export const ANONYMISED_TRANSLATION_KEY = 'Anonymised'

/**
 * Used where no intl is in reach. English is the portal's fallback language anyway, and any label
 * beats leaking the encrypted value.
 */
export const ANONYMISED_FALLBACK_LABEL = 'Anonymised'
